export const TranscriptToggle = ({
  open,
  onToggle,
  hidden = false
}: {
  open: boolean;
  onToggle: () => void;
  hidden?: boolean;
}) =>
  hidden ? null : (
    <button
      type="button"
      aria-expanded={open}
      onClick={onToggle}
      className="shrink-0 whitespace-nowrap text-sm font-bold text-primary-600 hover:text-primary-500 transition-colors"
    >
      {open ? "Hide transcript" : "Show transcript"}
    </button>
  );
